export const navLinks = [
  { href: "#topic", label: "热点议题" },
  { href: "#latest", label: "最新跟进" },
  { href: "#category", label: "行业分类" },
  { href: "#report", label: "深度专题" },
  { href: "#guide", label: "核实指南" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export const categories = [
  { id: "all", name: "全部" },
  { id: "food", name: "食品餐饮", desc: "配料标注、食品安全与后厨透明" },
  { id: "digital", name: "3C数码", desc: "参数宣传、定价与售后条款" },
  { id: "beauty", name: "美妆个护", desc: "成分宣称、功效验证与促销" },
  { id: "retail", name: "零售消费", desc: "营销话术、价格与退换规则" },
  { id: "finance", name: "金融保险", desc: "费率、免责条款与自动续费" },
  { id: "auto", name: "汽车出行", desc: "参数配置、召回与加价销售" },
  { id: "life", name: "本地生活", desc: "到店服务、团购与套餐套路" },
  { id: "internet", name: "互联网", desc: "隐私、会员与内容运营" },
];

export interface Topic {
  id: number;
  category: string;
  title: string;
  summary: string;
  tags: string[];
  concern: number;
  status: string;
  updated: string;
}

export const topics: Topic[] = [
  {
    id: 1,
    category: "food",
    title: "“零添加”“纯天然”标注的信息差观察",
    summary: "当包装上醒目标注成为营销卖点，消费者更需读懂配料表与执行标准。我们整理公开讨论中常见的标注话术与核查要点，帮助你分辨“宣传词”和“硬指标”的区别。",
    tags: ["配料表", "标注规范", "食品"],
    concern: 5,
    status: "持续关注",
    updated: "09-06",
  },
  {
    id: 2,
    category: "internet",
    title: "会员自动续费：扣费提醒为何总“迟一步”",
    summary: "连续包月、到期自动扣费是会员经济里的高频争议点。梳理公开的扣费提醒规则、取消入口与举证方式，让自动续费不再成为“忘记关就白扣钱”的坑。",
    tags: ["自动续费", "会员", "退款"],
    concern: 5,
    status: "持续关注",
    updated: "09-05",
  },
  {
    id: 3,
    category: "digital",
    title: "智能家电“堆参数”之后，谁在负责售后",
    summary: "功能越加越多、价格水涨船高，但故障率、维修费和上门时效往往缺少透明信息。本篇整理消费者在公开渠道反映集中的售后痛点与避坑建议。",
    tags: ["智能家电", "售后", "以旧换新"],
    concern: 4,
    status: "有回应",
    updated: "09-04",
  },
  {
    id: 4,
    category: "retail",
    title: "网红直播“全网最低价”的真实含金量",
    summary: "从预售定金到叠加优惠券，直播间标价背后的计算方式常让人眼花缭乱。梳理公开对比案例，教你核对到手价与退差规则，减少冲动下单。",
    tags: ["直播带货", "最低价", "比价"],
    concern: 4,
    status: "核查中",
    updated: "09-04",
  },
  {
    id: 5,
    category: "beauty",
    title: "“成分党”时代：功效宣称到底谁来验证",
    summary: "烟酰胺、玻色因、A醇……热门成分被反复营销。我们汇总公开文献与监管动态，厘清“添加成分”与“宣称功效”之间的证据距离。",
    tags: ["成分宣称", "功效", "美妆"],
    concern: 4,
    status: "持续关注",
    updated: "09-03",
  },
  {
    id: 6,
    category: "finance",
    title: "“首月0元”的保险，第二个月发生了什么",
    summary: "极低首期保费常伴随自动续费和长期分期。梳理公开的费率条款与取消路径，帮你算清年度真实成本，避开“看着便宜”的错觉。",
    tags: ["保险", "费率", "免赔"],
    concern: 4,
    status: "持续关注",
    updated: "09-03",
  },
  {
    id: 7,
    category: "life",
    title: "团购套餐“文字游戏”与到店加价的边界",
    summary: "‘不含锅底餐具’‘需另购小料’等附加说明常在详情页被弱化。汇总消费者公开反映较多的团购到店争议，整理下单前核对清单。",
    tags: ["团购", "到店", "加价"],
    concern: 3,
    status: "核查中",
    updated: "09-02",
  },
  {
    id: 8,
    category: "auto",
    title: "热门车型的加价与排队：谁在推动“紧俏”",
    summary: "部分车型‘需加装精品才能提车’的传闻在车友圈流传。本文只梳理公开讨论与投诉平台口径，帮助你识别销售话术并留存凭证。",
    tags: ["汽车", "加价", "订金"],
    concern: 3,
    status: "核查中",
    updated: "09-01",
  },
  {
    id: 9,
    category: "internet",
    title: "隐私条款里的“同意”：一键点下后数据去哪了",
    summary: "多数人在点击‘同意’前从不细看条款。整理公开的权限申请与数据用途说明方式，教你在授权前用两分钟做关键检查。",
    tags: ["隐私", "权限", "条款"],
    concern: 3,
    status: "持续关注",
    updated: "08-31",
  },
  {
    id: 10,
    category: "retail",
    title: "“满减凑单”与临期商品促销的冷思考",
    summary: "大促期间凑单满减、清仓临期常打包出现。梳理公开的比价与保质期提醒方式，帮你算清单品实际单价而非订单总额。",
    tags: ["大促", "临期", "比价"],
    concern: 3,
    status: "已核实",
    updated: "08-30",
  },
  {
    id: 11,
    category: "digital",
    title: "手机“环保不送充电器”之后的第三方配件坑",
    summary: "官方配件缺位，第三方快充头与线材鱼龙混杂。整理公开的协议认证识别方法，避免‘便宜线材’损伤设备与引发安全隐患。",
    tags: ["配件", "快充", "认证"],
    concern: 3,
    status: "已核实",
    updated: "08-29",
  },
  {
    id: 12,
    category: "food",
    title: "预制菜进校园与透明化的呼声",
    summary: "围绕预制菜标准的讨论持续升温。本文仅整理公开的标准动态与标识建议，帮助家长判断信息来源、理性看待争议。",
    tags: ["预制菜", "标准", "透明"],
    concern: 4,
    status: "持续关注",
    updated: "08-28",
  },
];

export interface Feed {
  id: number;
  time: string;
  category: string;
  title: string;
  desc: string;
  status: string;
}

export const feeds: Feed[] = [
  {
    id: 1,
    time: "09-06 10:20",
    category: "食品餐饮",
    title: "某连锁茶饮配料标示争议被监管部门关注",
    desc: "围绕部分现制茶饮是否在菜单醒目位置公示奶基底与用料的讨论增多，已留意监管口径与门店整改动态。",
    status: "持续关注",
  },
  {
    id: 2,
    time: "09-06 08:45",
    category: "互联网",
    title: "多款App被提示需明示自动续费取消入口",
    desc: "结合公开通报整理自动续费提醒与取消路径的变化，近期相关新规对会员扣费提出更细要求。",
    status: "有回应",
  },
  {
    id: 3,
    time: "09-05 18:30",
    category: "3C数码",
    title: "网购家电“只换不修”服务细则引发讨论",
    desc: "消费者对退换货定义、旧件回收与运费承担的认知差异较大，已整理公开规则供比对。",
    status: "核查中",
  },
  {
    id: 4,
    time: "09-05 14:10",
    category: "金融保险",
    title: "‘首月低价’保险产品的年化成本被反复比较",
    desc: "多篇公开测评指出，续期费率与优惠期后价格才是关键，提醒投保前核清整年保费。",
    status: "已核实",
  },
  {
    id: 5,
    time: "09-04 20:00",
    category: "美妆个护",
    title: "美白功效宣称需提供检测报告成为新关注点",
    desc: "围绕功效型护肤品的宣称与检测依据，整理公开监管口径与消费者自查要点。",
    status: "持续关注",
  },
  {
    id: 6,
    time: "09-04 09:15",
    category: "本地生活",
    title: "节假日团购套餐加价规则被集中反映",
    desc: "多起‘到店需补差价’案例引发讨论，已整理平台规则与保留凭证的建议。",
    status: "核查中",
  },
];

export interface Report {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  readMin: number;
  tag: string;
  image: string;
}

export const reports: Report[] = [
  {
    id: 1,
    category: "消费避坑",
    title: "读懂配料表：三步分辨“零添加”是真还是文字游戏",
    excerpt: "从配料排序、营养成分表到执行标准号，一份清单帮你把‘宣传词’翻译成可核对的信息，下单前多花一分钟。",
    readMin: 6,
    tag: "避坑指南",
    image: "https://readdy.ai/api/search-image?query=Warm%20editorial%20still%20life%20of%20food%20packaging%20label%20and%20ingredient%20table%20on%20warm%20beige%20paper%2C%20vintage%20vermilion%20red%20rubber%20stamp%20nearby%2C%20soft%20shadow%2C%20amber%20golden%20lighting%2C%20minimal%20magazine%20style%2C%20high%20detail%2C%20no%20people%2C%20no%20readable%20brand&width=720&height=540&seq=rep-01&orientation=landscape",
  },
  {
    id: 2,
    category: "会员研究",
    title: "自动续费防坑清单：下单前先确认这五件事",
    excerpt: "扣费周期、取消入口、到期提醒、叠加优惠与退款规则——把会员“买前须知”讲清楚，告别无声扣款。",
    readMin: 5,
    tag: "清单",
    image: "https://readdy.ai/api/search-image?query=Editorial%20abstract%20of%20smartphone%20screen%20glow%20with%20stacked%20credit%20card%20and%20receipts%20on%20warm%20paper%2C%20amber%20and%20vermilion%20red%20color%20accents%2C%20dramatic%20side%20light%2C%20subscription%20concept%2C%20minimal%20premium%20magazine%20aesthetic%2C%20no%20people%2C%20no%20readable%20text&width=720&height=540&seq=rep-02&orientation=landscape",
  },
  {
    id: 3,
    category: "信源方法",
    title: "如何判断一条“企业黑料”值不值得信：信源核查四问",
    excerpt: "出处是否可追溯、原始材料是否完整、多方说法是否一致、时间线是否矛盾——用四问过滤无效噪音。",
    readMin: 8,
    tag: "方法论",
    image: "https://readdy.ai/api/search-image?query=Editorial%20flat-lay%20of%20vintage%20newspaper%20sheets%20with%20a%20brass%20magnifying%20glass%20on%20warm%20paper%20background%2C%20ink%20contrast%2C%20amber%20gold%20highlights%2C%20investigative%20journalism%20mood%2C%20minimal%20composition%2C%20no%20people%2C%20no%20readable%20text&width=720&height=540&seq=rep-03&orientation=landscape",
  },
  {
    id: 4,
    category: "行业报告",
    title: "家电以旧换新补贴怎么用不踩坑：金额与流程拆解",
    excerpt: "补贴范围、旧机估价、支付与立减规则各地有别，本篇帮你对照清单核验，避免‘领了券却用不上’。",
    readMin: 7,
    tag: "行业报告",
    image: "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20home%20appliance%20remote%20control%20and%20toolkit%20on%20warm%20paper%20background%2C%20amber%20and%20deep%20red%20accents%2C%20soft%20studio%20light%2C%20consumer%20report%20style%2C%20minimal%20magazine%20aesthetic%2C%20no%20people%2C%20no%20readable%20brand&width=720&height=540&seq=rep-04&orientation=landscape",
  },
];

export const guideSteps = [
  {
    no: "01",
    icon: "ri-focus-2-line",
    title: "溯源：找到第一手出处",
    desc: "先确认信息来自企业公告、监管通报、官方客服或具备公信力的媒体，而不是二手截图与匿名小号。没有出处的说法，一律存疑。",
  },
  {
    no: "02",
    icon: "ri-archive-drawer-line",
    title: "比对：看多方如何回应",
    desc: "把消费者的反映、企业说明与监管口径放在一起看。时间顺序是否合理、细节是否相互矛盾，往往是判断真伪的关键。",
  },
  {
    no: "03",
    icon: "ri-git-merge-line",
    title: "求证：让证据说话",
    desc: "优先依赖可下载的原始材料：合同、小票、检测报告、审批记录。能落到实处的证据，才值得被认真对待。",
  },
];

export const faqs = [
  {
    q: "99黑料上的内容一定准确吗？",
    a: "我们不承诺绝对准确，但坚持每条议题都标注核实状态与更新日期。凡是缺乏公开信源、无法交叉验证的说法，我们会明确标注“核查中”，绝不把猜测当作事实发布。",
  },
  {
    q: "会点名批评具体企业或品牌吗？",
    a: "我们以“议题观察”而非“点名定罪”的方式呈现内容。涉及具体企业时，只转述有公开信源可查的事实，并同步呈现企业回应，尽力保持信息对称。",
  },
  {
    q: "如何向你提交线索或反馈意见？",
    a: "你可以在页面底部的“意见与反馈”表单留下信息，尽量附上可追溯的信源链接。我们只会在有据可查时跟进，匿名且无出处的传闻一般不予采用。",
  },
  {
    q: "内容多久更新一次？",
    a: "热点议题与最新跟进通常保持每日滚动更新，深度专题按议题重要程度不定期发布。每条内容顶部都会标注最后更新日期，便于你判断时效。",
  },
  {
    q: "可以转载或引用99黑料的内容吗？",
    a: "欢迎在注明出处的前提下做简短引用。但请勿断章取义或把“观察类”表述曲解为定性结论，涉及企业评价时请务必保留我们的核实状态说明。",
  },
];

export const testimonials = [
  {
    name: "普通上班族 · 网购爱好者",
    content: "以前看促销总是一头雾水，这里把满减、续费和临期品的门道讲得清楚，下单前会先翻一翻专题清单。",
  },
  {
    name: "长期关注消费者的读者",
    content: "最打动我的是“不点名定罪”的克制，每条都标了核实状态，比那些看到截图就开骂的号靠谱太多。",
  },
  {
    name: "内容行业从业者",
    content: "作为同行很认可它“只信有出处的信息”的原则。避坑指南真的能当操作手册用，不是标题党。",
  },
];